import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUser(response.data);
          setIsAdmin(response.data.role === "admin");
        } catch (error) {
          localStorage.removeItem("token");
          setToken(null);
          setUser(null);
          setIsAdmin(false);
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { token: newToken, email: userEmail, name } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser({ email: userEmail, name, role: "customer" });
    return response.data;
  };

  const adminLogin = async (password) => {
    const response = await axios.post(`${API}/admin/login`, { password });
    const { token: newToken } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser({ email: "admin", name: "Administrator", role: "admin" });
    setIsAdmin(true);
    return response.data;
  };

  const register = async (data) => {
    const response = await axios.post(`${API}/auth/register`, data);
    const { token: newToken, email, name } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser({ email, name, role: "customer" });
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, isAdmin, login, adminLogin, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
